import React from "react";
import { UI_LANGUAGES, useLanguage } from "../i18n/LanguageContext";

export const LanguageSwitcher = () => {
  const { lang, setLanguage } = useLanguage();
  return (
    <div className="flex items-center rounded-full p-0.5 text-xs font-medium" style={{ backgroundColor: "var(--eunoia-whisper)" }} data-testid="language-switcher">
      {UI_LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLanguage(l.code)}
          aria-pressed={lang === l.code}
          data-testid={`language-switch-${l.code}`}
          className="px-2.5 py-1 rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--eunoia-accent)]"
          style={lang === l.code ? { backgroundColor: "white", color: "var(--eunoia-deep)" } : { color: "var(--eunoia-soft)" }}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};
